import { createFileRoute } from "@tanstack/react-router";
import { activeMedicationsQueryOptions, medicalsAllergiesQueryOptions, medicalsConditionsQueryOptions } from "~/features/dashboard/pages/medicals/api/queries";

import { WeightLossPage } from "~/features/dashboard/pages/weight-loss";
import { tasksQueryOptions } from "~/features/dashboard/pages/weight-loss/api/queries/tasks";

export const Route = createFileRoute("/(dashboard)/dashboard/weight-loss/")({
  loader: ({ context }) => {
    context.queryClient.ensureQueryData(tasksQueryOptions())
    context.queryClient.ensureQueryData(medicalsAllergiesQueryOptions())
    context.queryClient.ensureQueryData(medicalsConditionsQueryOptions())
    context.queryClient.ensureQueryData(activeMedicationsQueryOptions())
  },
  component: () => (
    <main
      role="main"
      aria-label="weight loss content"
      className="min-h-screen w-full px-4 sm:px-[32px] lg:px-[200px]"
    >
      <WeightLossPage />
    </main>
  ),

  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Weight Loss</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
